import { Moment } from 'moment';

export enum InstallmentModalEnum {
  one = 'one',
  moreThanOne = 'moreThanOne',
}

export interface InstallmentFormValues {
  //One
  dueDate: Moment;
  number: string;
  value: number;
  invoiceId: number;
  // More than one
  dueDateFirstInstallment: Moment;
  installmentValue: number;
  quantityInstallments: number;
}

export interface CreateOneInstallment {
  dueDate: string;
  number: string;
  value: number;
  invoiceId: number;
}

export interface CreateMoreThanOneInstallment {
  invoiceId: number;
  dueDateFirstInstallment: string;
  installmentValue: number;
  quantityInstallments: number;
}

export interface UpdateOneInstallment {
  dueDate: string;
  number: string;
  id: number;
  value: number;
  invoiceId: number;
}

export interface InstallmentOneResponse {
  dueDate: string;
  id: number;
  number: string;
  value: number;
}

export interface InstallmentMoreThanOneResponse {
  dueDate: string;
  id: number;
  number: string;
  value: number;
}
